import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import LandingPage from "../views/LandingPage.vue";

import Profile from "../views/Profile.vue";
import Schools from "../views/Schools.vue";
import School from "../views/School.vue";
import Asset from "../views/Asset.vue";
import Library from "../views/Library.vue";
import Class from "../views/Class.vue";
import { authGuard } from "../auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        authenticated: Home,
        unauthenticated: LandingPage
      }
    },
    {
      path: "/schulen",
      name: "schulen",
      component: Schools,
      // beforeEnter: authGuard
    },
    {
      path: "/schule/:id",
      name: "schule",
      component: School
    },
    {
      path: "/schule/:schoolId/bibliothek/",
      name: "library",
      component: Library
    },
    {
      path: "/schule/:schoolId/bibliothek/:assetId",
      name: "asset",
      component: Asset
    },
    {
      path: "/schule/:schoolId/klasse/:classId",
      name: "klasse",
      component: Class
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      beforeEnter: authGuard
    }
  ]
});

export default router;
